<template>
  <div class="space-between-y">
    <el-dialog title="教师详情" :visible.sync="detail.dialog" width="800px">
      <div class="space-between-y">
        <teacher-detail :id="detail.id" v-if="detail.dialog"></teacher-detail>

        <miu-desc></miu-desc>

        <div class="container-center">
          <template v-if="detail.vo.examine === 'PENDING'">
            <el-button @click="examine(0)">审核驳回</el-button>
            <el-button @click="examine(1)" type="primary">审核通过
            </el-button>
          </template>

          <template v-else>
            <el-button @click="examine(null)">撤销审核</el-button>
          </template>
        </div>
      </div>


    </el-dialog>

    <div class="space-between-x">
      <input-item label="审核状态">
        <el-select clearable filterable v-model="filter.status" placeholder="请选择审核状态">
          <el-option label="所有" :value="null"></el-option>
          <el-option label="未审核" value="PENDING"></el-option>
          <el-option label="已通过" value="APPROVED"></el-option>
          <el-option label="未通过" value="REJECTED"></el-option>
        </el-select>
      </input-item>
      <input-item label="关键字">
        <el-input clearable v-model="filter.keyword" placeholder="请输入关键字"></el-input>
      </input-item>
      <input-item>
        <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
      </input-item>
    </div>

    <el-table :data="list" border stripe>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="name" label="教师姓名"></el-table-column>
      <el-table-column prop="idNumber" label="身份证号"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="address" label="注册地区">
        <template slot-scope="scope">
          <line-overflow v-if="scope.row.addressProvince" :content="scope.row.addressProvince + '-'+scope.row.addressCity"></line-overflow>
          <div v-else class="info-text">无</div>
        </template>
      </el-table-column>
      <el-table-column width="80" prop="examine" label="审核状态">
        <template slot-scope="scope">
          <el-tag size="mini" type="info" v-if="scope.row.examine === 'PENDING'">未审核</el-tag>
          <el-tag size="mini" type="success" v-if="scope.row.examine === 'APPROVED'">已通过</el-tag>
          <el-tag size="mini" type="danger" v-if="scope.row.examine === 'REJECTED'">未通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="个性签名">
        <template slot-scope="scope">
          <line-overflow :content="scope.row.title"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="详细介绍">
        <template slot-scope="scope">
          <line-overflow :content="scope.row.desc"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleShow(scope.row)">查看</el-button>
          <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)" disabled>删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getData()"></pagination>

  </div>
</template>

<script>
import {miuTeacher} from "@/api/miu/teacher";
import TeacherDetail from "@/components/miu/TeacherDetail.vue";
import Pagination from "@/components/base/layout/Pagination.vue";
import InputItem from "@/components/base/layout/InputItem.vue";
import MiuDesc from "@/components/MiuDesc.vue";
import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";

export default {
  name: 'MiuTeacher',
  components: {
    LineOverflow,
    MiuDesc,
    InputItem,
    Pagination,
    TeacherDetail
  },

  data() {
    return {
      list: [],

      detail: {
        id: null,
        dialog: false,
        vo: {}
      },

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      filter: {
        keyword: "",
        status: null,
      }

    };
  },

  created() {
    this.getData();
  },

  methods: {
    examine(code) {
      // 审批通过
      if (code === 1) {
        this.$confirm("确定通过审核吗？").then(() => {
          miuTeacher.examine(this.detail.id, 'APPROVED').then(() => {
            this.$message.success("审核成功");
            this.detail.dialog = false;
            this.getData();
          })
        })
      }
      // 审批驳回
      else if (code === 0) {
        this.$prompt("请输入驳回理由", "驳回理由", {}).then(({value}) => {
          miuTeacher.examine(this.detail.id, 'REJECTED', value).then(() => {
            this.$message.success("审核成功");
            this.detail.dialog = false;
            this.getData();
          })
        })
      }

      // 撤销审核
      else if (code === null) {
        this.$confirm("确定撤销审核吗？该记录将还原到未审核状态！").then(() => {
          miuTeacher.examine(this.detail.id, 'PENDING', null).then(() => {
            this.$message.success("审核成功");
            this.detail.dialog = false;
            this.getData();
          })
        })
      }
    },

    getData() {
      miuTeacher.list(this.page.size, this.page.current, this.filter.status, this.filter.keyword).then(res => {
        let page = res.data;
        this.page.total = page.total;
        this.list = page.list;
      });
    },
    handleShow(item) {
      this.detail.id = item.id;
      this.detail.dialog = true;
      this.detail.vo = item;
    },
  },

};
</script>

<style scoped>
</style>
